/* eslint-disable no-console */
import React, { useContext, useState } from 'react';
import { DialogContent, Tooltip } from '@mui/material';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';
import CloseIcon from '@mui/icons-material/Close';
import { LanguageContext } from '../../../../libs/Context';
import '../../../MediaDrive/style.css';
import ReactPlayer from 'react-player';

const Preview = (props:any) =>
{
	const { previewDoc, ind, handleClosePreview, mediaType } = props;
	const [ arrInd, setArrInd ] = useState<number>(ind);
	const { language } = useContext(LanguageContext);

	const type = ![ 'image', 'video', 'podcast' ]?.includes(mediaType) && previewDoc?.url.substring(previewDoc?.url.lastIndexOf('.') + 1);

	const documentExtArray = [ 'pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'odt', 'ods', 'odp', 'rtf', 'txt' ];

	const prevBtn = () =>
	{
		setArrInd((prev:any) => prev - 1);
	};

	const nxtBtn = () =>
	{
		setArrInd((prev:any) => prev + 1);
	};

	return (
		<div className='flexCol mediaPreview alignCntr justifyCntr scrollY'>
			<button className='flexInline slideBtns slideCloseBtn alignCntr justifyCntr'
				tabIndex={0}
				onKeyUp={(e) => { e.key === 'Enter' && handleClosePreview(); }}
				aria-label='close'
				onClick={handleClosePreview}
			>
				<Tooltip title={language?.close}>
					<CloseIcon />
				</Tooltip>
			</button>
			<div className='resPColRow fullHeight'>
				<div className='flexRow alignCntr justifyCntr previewImage '>
					{mediaType === 'image' && <div className='flexRow mediaSliderMain alignCntr justifyCntr'>
						{previewDoc.urls?.length > 1 &&
						<>
							<button className={`prev ${arrInd === 0 && 'disableMode'}`}
								tabIndex={0}
								onKeyUp={(e) => { e.key === 'Enter' && prevBtn(); }}
								aria-label='prev'
								onClick={prevBtn}
							>❮</button>
							<button className={`next ${arrInd === (previewDoc.urls?.length - 1) && 'disableMode'}`}
								tabIndex={0}
								onKeyUp={(e) => { e.key === 'Enter' && nxtBtn(); }}
								aria-label='next'
								onClick={nxtBtn}
							>❯</button>
						</>}
						<div className=' flexRow mediaSlideItem alignCntr justifyCntr'>
							<img src={previewDoc.urls ? previewDoc.urls[arrInd] : previewDoc.url}
								alt='docviewimg' loading='lazy'
							/>
						</div>
					</div>}
					{mediaType === 'video' &&
						<div className='flexRow mediaPreviewParent alignCntr justifyCntr'>
							<div className='flexRow mediaPreviewChild alignCntr justifyCntr brdrRadiusXSM'>
								{previewDoc.isYouTube
									? (
										<iframe
											src={previewDoc.url}
											width='100%'
											height='100%'
											frameBorder='0'
											allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
											allowFullScreen
											title='YouTube video player'
										/>
									)
									: (
										<ReactPlayer
											url={previewDoc.url}
											controls
											width='100%'
											height='100%'
											config={{
												file : {
													attributes : {
														style : {
															width     : '100%',
															height    : '100%',
															objectFit : 'cover'
														}
													}
												}
											}}
											light={previewDoc.thumbnail || true}
										/>
									)
								}
							</div>
						</div>}
					{ mediaType === 'podcast' &&
					<div className='flexCol alignCntr podcastCntr justifyCntr'>
						<div className=' flexMinHeightCol podcastItem alignCntr justifyCntr'>
							<img src={previewDoc?.thumbnail || '/images/podcast_default.jpg'} alt='contentImg' loading='lazy'/>
						</div>
						<div className='flexRow audioCntr alignCntr justifyCntr'>
							<audio controls >
								<source src={previewDoc?.url} type='audio/ogg' width='var(--percent100)' />
							</audio>
						</div>

					</div>
					}
					{![ 'image', 'video', 'podcast' ]?.includes(mediaType) &&
					<div className='flexMinHeightCol alignCntr fullHeight '>
						<div className=' flexRow previewSlideItem  justifyCntr'>
							<div className='flexRow justifyCntr edmImgCntr'>

								{documentExtArray.includes(type) && (
									<DialogContent className='dialogContent508'>
										<div className='mediaDocBackground'>
											<DocViewer
												className='docViewCntr'
												pluginRenderers={DocViewerRenderers}
												documents={[
													{
														uri      : previewDoc?.url,
														fileType : previewDoc?.key?.split('.')?.pop()
													}
												]}
											/>
										</div>
									</DialogContent>
								)}
							</div>
						</div>
					</div>}
				</div>
			</div>
		</div>
	);
};

export default Preview;
